import { useRef } from 'react';
import { uniqueId } from '@zen/common-utils';

/**
 * Get a unique ID which stays the same for the entire component lifecycle
 * @returns {string}
 */
export default function useUniqueId() {
  return useRef(uniqueId()).current;
}
